<template>
  <UContainer
    v-if="items && items.length > 0"
    :class="sectionContainer.external"
  >
    <USeparator :ui="sectionSeparator" />
    <TTitle tag="h2" v-bind="sectionTitle">
      {{ t('views.cottage-list.reviews.title', { name: title }) }}
    </TTitle>
    <SReviews
      v-if="transformedReviews.items.length > 0"
      v-bind="transformedReviews"
      variant="seo-listing"
    />
  </UContainer>
</template>

<script setup lang="ts">
import type { schemaType } from '~~/shared/api/rurality/v3/cottage-reviews/destination/detail/schema'
import { useToSReviews } from '~/composables/transformers/useToSReviews'
import { sectionTitle } from '~~/modules/design-system/utils/components/t-title'
import { sectionContainer } from '~~/modules/design-system/utils/nuxt-ui-config/components/container'
import { sectionSeparator } from '~~/modules/design-system/utils/nuxt-ui-config/components/separator'

const props = defineProps<{
  items: schemaType['reviews']
  title: string
}>()

const transformedReviews = useToSReviews().fromRuralityDestinationReviews({
  dataIn: props.items,
})
</script>
